const images = {
  logoDark: require('./logo-dark.png'),
  logoLight: require('./logo-light.png'),
  masdarLogoDark: require('./masdar-logo-blue.svg'),
  masdarLogoLight: require('./masdar-logo-white.svg')
}

export default images
